import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

interface UserGrowthChartProps {
  data: any[];
}

export function UserGrowthChart({ data }: UserGrowthChartProps) {
  // Usar dados demo se não houver dados reais
  const displayData = data && data.length > 0 ? data : generateDemoData();

  return (
    <div
      className="rounded-2xl p-6 backdrop-blur-sm border"
      style={{
        backgroundColor: '#111116',
        borderColor: '#1e1e25',
      }}
    >
      <div className="mb-6">
        <h3 style={{ color: '#f5f5f7' }} className="text-lg font-semibold">
          Crescimento de Usuários
        </h3>
        <p style={{ color: '#8a8a95' }} className="text-sm">
          Últimos 30 dias
        </p>
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={displayData} margin={{ top: 5, right: 30, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(138, 138, 149, 0.1)" />
          <XAxis
            dataKey="date"
            stroke="#75757f"
            style={{ fontSize: '12px' }}
          />
          <YAxis stroke="#75757f" style={{ fontSize: '12px' }} />
          <Tooltip
            contentStyle={{
              backgroundColor: '#131318',
              border: '1px solid #1e1e25',
              borderRadius: '8px',
              color: '#f5f5f7',
            }}
            cursor={{ stroke: 'rgba(180, 163, 255, 0.3)', strokeWidth: 2 }}
          />
          <Legend wrapperStyle={{ color: '#75757f' }} />
          <Line
            type="monotone"
            dataKey="usuarios"
            stroke="#b4a3ff"
            strokeWidth={2}
            dot={{ fill: '#b4a3ff', r: 4 }}
            activeDot={{ r: 6 }}
            name="Total"
            isAnimationActive={true}
          />
          <Line
            type="monotone"
            dataKey="premium"
            stroke="#08d660"
            strokeWidth={2}
            dot={{ fill: '#08d660', r: 4 }}
            activeDot={{ r: 6 }}
            name="Premium"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

function generateDemoData() {
  const data = [];
  for (let i = 29; i >= 0; i--) {
    const date = new Date();
    date.setDate(date.getDate() - i);
    data.push({
      date: date.toLocaleDateString('pt-BR', { month: 'short', day: 'numeric' }),
      usuarios: Math.floor(200 + i * 8 + Math.random() * 50),
      premium: Math.floor(40 + i * 3 + Math.random() * 20),
    });
  }
  return data;
}
